/*
 * Copyright 2022. NXGN Management, LLC. All Rights Reserved.
 */

export enum AppEventType {
  Login = "LOGGED_IN",
  menuCollapse = "MENU_COLLAPSE"
}
